var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"task-status",attrs:{"type":_vm.taskStatusType}},[_vm._v(" "+_vm._s(_vm.taskStatus)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }